
import React from 'react';
import cIf from 'classnames';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

export interface PageSectionProps {
    sectionDone?: boolean;
    children: React.ReactNode;
    afterGetPosition?: (position: { x: number, y: number }) => void;
}

export const PageSection = createClass<PageSectionProps>({
    displayName: "PageSection",

    PropTypes: {
        sectionDone: PropTypes.bool,
        children: PropTypes.element,
        afterGetPosition: PropTypes.func
    },

    getDefaultProps: function () {
        return { 
            sectionDone: false,
            afterGetPosition: null,
            children: null
         };
    },

    getCtlPosition() {
        const position = $(this.ctl).position(); // TODO: Use React ref to get position and delete jquery dependency
        return { x: position.left, y: position.top };
    },

    componentDidMount() {
        if(this.props.afterGetPosition != null) this.props.afterGetPosition(this.getCtlPosition());
    },

    render() {
        return (
            <div className={cIf("container-fluid", { "done-section": this.props.sectionDone } )}
                 ref={(ctl) => { this.ctl = ctl; }}>
                {this.props.children}
            </div>
        );
    }
});